/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, type ReactNode } from 'react'

import dynamic from 'next/dynamic'

import ModalChooseLocation from '@/components/Popup/ModalChooseLocation'
import { useNotification } from '@/containers'
import { Footer } from '@/layouts/Footer'
import { Header } from '@/layouts/Header'
import { type BannerList } from '@/types'

const NotificationBar = dynamic(() => import('@/components/NotificationBar'), {
  ssr: false
})

const OnDevelopment = dynamic(() => import('@/components/OnDevelopment'), {
  ssr: false
})

type IMainProps = {
  meta?: ReactNode
  children: ReactNode
  hideFooter?: boolean
  banner?: BannerList[]
  bgColor?: string
  bottomMenu?: any
  style?: any
  page?: string
  className?: string
  backgroundImage?: string
}

const Main = (props: IMainProps) => {
  const { overlayMegaMenu, setOverlayMegaMenu } = useNotification()

  useEffect(() => {
    setOverlayMegaMenu(false)
  }, [])

  return (
    <>
      {props.meta}
      <div className=' w-full text-dark-200 antialiased'>
        <Header page={props.page} />
        {overlayMegaMenu && <div className='fixed left-0 top-0 z-[999998] h-full w-full bg-dark-900/50'></div>}
        <NotificationBar />
        <main
          style={{
            backgroundColor: props.bgColor || 'transparent'
          }}
          className={`main-content text-base ${props.bgColor ? props.bgColor : ''} ${
            props.className ? props.className : ''
          }`}
        >
          <div className={`mainWrapper  mx-auto w-full ${props.page === 'homepage' ? '' : 'container'}`}>
            {props.children}
          </div>
        </main>
        {!props.hideFooter && <Footer />}
        <OnDevelopment />
        <ModalChooseLocation />
      </div>
    </>
  )
}

export { Main }
